<div class="status-badge-group">
    <span [class]="getBadgeClass()" class="status-badge">
        {{label}}
    </span>
    <span *ngIf="getFundOperationalStatusLabel() as operationalLabel"
        [class]="getFundOperationalStatusClass()"
        class="status-badge">
        {{ operationalLabel }}
    </span>
    <span *ngFor="let tag of getTransferTags()"
        class="status-badge"
        [class.status-badge-transfer]="tag !== 'Transferência a confirmar'"
        [class.status-badge-transfer-confirm]="tag === 'Transferência a confirmar'">
        {{ tag }}
    </span>
</div>